// extracted by mini-css-extract-plugin
export default {"Section":"Content_Section__uarFN"};